import React, { useEffect, useState } from 'react'
// import Header from '../../components/header/Header'
import { useNavigate, useParams } from "react-router-dom";
import { getFetcher, postFetcher } from '../../../api/fetchers';
import { endpoints } from '../../../api/endpoints';
// import Navbar from '../../components/navbar/Navbar';
// import Footer from '../../components/footer/Footer';
import { ToastContainer, toast } from 'react-toastify';
import { useUser } from '../../context/UserContext';
import { useLanguage } from '../../context/LanguageContext';




const DailyCampaignDetail: React.FC = () => {
  const { t } = useLanguage();
  const { id } = useParams();
  const [campaign, setCampaign] = useState<any>({});
  const [mainImage, setMainImage] = useState('');
  const [isCheck, setIsCheck] = useState(false);
  const { user } = useUser();


  const navigate = useNavigate();

  useEffect(() => {
    const getCampaignDetail = async () => {
      try {
        const response = await getFetcher(endpoints.campaigns.getSingleDailyCampaign.replace('{id}', id || ''));
        if (response && response.dailyCampaign) {
          setCampaign(response.dailyCampaign);
          const images = (response.dailyCampaign.product.images);
          setMainImage(images[0]);
        } else {
          // toast.error(campaignResponse.message || 'Ürün bulunamadı');
          toast.error(t('toastMessage', 'campErr'));
        }
      } catch (error) {
        toast.error("Error");
      }
    };
    getCampaignDetail();
  }, []);



  // add user to daily campaign
  const handleClickJoinCampaign = async () => {
    try {
      const response = await postFetcher(endpoints.user.addUserToDailyCampaign, {
        arg: {
          dailyCampaignId: id,
          userId: user?.id
        }
      });

      if (response.result) {
        toast.success(t('toastMessage', 'campSuc'));
        setIsCheck(true);
      } else {
        if (response.message == "The user has already been added to this daily campaign but has been removed from the daily campaign by the supplier") {
          toast.error(t('toastMessage', 'rate24'));
          setIsCheck(false);
        } else {
          toast.info(t('toastMessage', 'campExist'));
          setIsCheck(true);
        }
      }
    } catch (error) {
      setIsCheck(false);
      console.log(error);
    }
  }


  return (
    <main className="flex flex-grow flex-col min-h-screen">
      {/* <Header />
      <Navbar /> */}
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false}
        closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

      <h1
        id="title"
        className={`text-center text-4xl text-primary-color my-16 `}
      >
        Kampanya Detayları
      </h1>

      <div className="w-3/4 mx-auto mb-4 bg-gray-50">
        <img src={mainImage} alt="Campaign Image" className=' object-contain h-[500px] w-1/2 mx-auto hover:scale-95 transition-all rounded-xl shadow-xl bg-white my-4' />
        {/*Geri sayım kısmı ve Buton*/}
        <div className="flex flex-col md:justify-between items-center md:flex-row mt-6 ">
          <div>
            <p className="text-primary-color md:ml-20 md:w-3/5 flex self-center w-full">
              {campaign?.title} 🎁💐🥳
            </p>
          </div>
          <div className="md:w-2/5 w-full flex md:justify-end justify-center md:mr-20">

            {
              isCheck ? (
                <div>
                  <button onClick={() => navigate(`/product-detail/${campaign?.productId}`)} className="text-2xl mt-5 mb-5 bg-primary-color hover:bg-color-gray text-white hover:border-2 hover:border-primary-color hover:text-primary-color py-2 px-12 rounded-md">
                    İncele
                  </button>

                </div>
              ) : (
                <div>
                  <button onClick={handleClickJoinCampaign} className="text-2xl mt-5 mb-5 bg-primary-color mr-4 hover:bg-color-gray text-white hover:border-2 hover:border-primary-color hover:text-primary-color py-2 px-12 rounded-md">
                    Katıl
                  </button>
                </div>
              )
            }
          </div>
        </div>

        <h1
          id="title"
          className="text-center text-2xl my-16"
        >
          Kampanya Detayları
        </h1>

        <div className="space-y-4 list-disc text-gray-400 mb-10 px-10 text-center ">
          {campaign?.description}
        </div>
      </div>

      {/* <Footer /> */}
    </main>
  )
}

export default DailyCampaignDetail;